<template>
	<div class="shipping-options">
		<div>
			<LeadLockup lead="Shipping Method" />

			<div v-if="!shippingAddressSynced" class="shipping-options__well">
				<div
					v-if="modifyingCart"
					class="shipping-options__skeleton"
					aria-busy="true"
					aria-live="polite"
					role="alert"
				>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
				</div>

				<VSWell v-else size="sm">
					<p>
						Enter your shipping address to view available shipping
						methods
					</p>
				</VSWell>
			</div>

			<VSRadioGroup v-else legend="Select a shipping option">
				<VSRadio
					v-for="option in shippingOptions"
					:id="option.id"
					:key="option.id"
					v-model="shippingMethodId"
					:value="option.id"
					name="shipping"
					:disabled="disableSelection"
					:label="`${option.name} (${
						option.detail.split(' ')[0]
					} days)`"
					:context="option.price"
				/>
			</VSRadioGroup>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { VSRadioGroup, VSRadio } from '@component/UI/controls';
import LeadLockup from '@component/user-backend/Checkout/V4/LeadLockup.vue';
import VSWell from '@component/UI/VSWell.vue';

export default {
	components: {
		LeadLockup,
		VSRadioGroup,
		VSRadio,
		VSWell,
	},

	data() {
		return {
			shippingMethodId: null,
		};
	},

	computed: {
		...mapState('checkout', ['cart', 'modifyingCart']),
		...mapGetters('checkout', [
			'shippingOptions',
			'shippingAddressSynced',
			'modifyingOrSubmittingOrder',
		]),
		disableSelection() {
			return (
				this.modifyingOrSubmittingOrder ||
				this.shippingMethodId !== this.cart.shipping_category.id
			);
		},
	},

	watch: {
		shippingMethodId() {
			if (!this.shippingAddressSynced) return;

			if (this.shippingMethodId === this.cart.shipping_category.id)
				return;

			this.updateShippingMethod(this.shippingMethodId);
		},
		'cart.shipping_category': function () {
			if (
				this.cart.shipping_category &&
				this.cart.shipping_category !== this.shippingMethodId
			) {
				this.shippingMethodId = this.cart.shipping_category.id;
			}
		},
	},

	beforeMount() {
		if (this.cart.shipping_category) {
			this.shippingMethodId = this.cart.shipping_category.id;
		}
	},

	methods: mapActions('checkout', ['updateShippingMethod']),
};
</script>

<style lang="scss" scoped>
.shipping-options {
	display: grid;
	gap: var(--size-lg);

	&__skeleton {
		display: grid;
		gap: var(--size-md);
		grid-template-columns: var(--size-md) 1fr 60px;
		padding: var(--size-md);

		> span {
			border-radius: var(--size-sm);
			height: var(--size-lg);
			background: var(--gray-300);

			&:nth-child(1) {
				width: var(--size-lg);
				height: var(--size-lg);
				border-radius: var(--size-lg);
			}
		}
	}
}
</style>
